import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import { gradeOptions } from '../../data/onboardingData';

const { FiArrowRight, FiLock } = FiIcons;

function GradeStep({
  selectedGrade,
  onSelect,
  onContinue,
  eyebrow = 'For the parent',
  title = 'Confirm Emmanuel’s grade',
  description = 'This helps Quantix use the right curriculum level before Emmanuel begins the quick diagnostic.',
  showContinue = true,
  showHeading = true
}) {
  return (
    <div>
      {showHeading ? (
        <>
          <span className="eyebrow">{eyebrow}</span>
          <h1 className="mt-3 font-['Manrope'] text-3xl font-bold tracking-[-0.04em] text-[#24302d]">
            {title}
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-6 text-[#6c7773]">
            {description}
          </p>
        </>
      ) : (
        <span className="eyebrow">{eyebrow}</span>
      )}

      <div className={`${showHeading ? 'mt-7' : 'mt-3'} grid grid-cols-2 gap-3 sm:grid-cols-3`}>
        {gradeOptions.map((grade) => (
          <button
            className={`rounded-xl border px-4 py-4 text-left transition ${
              grade.enabled
                ? selectedGrade === grade.value
                  ? 'border-[#7c3aed] bg-[#f3e8ff] text-[#5b21b6]'
                  : 'border-[#e3e4de] bg-white text-[#24302d] hover:border-[#7c3aed]'
                : 'cursor-not-allowed border-[#ecece8] bg-[#f8f8f5] text-[#9aa19d]'
            }`}
            disabled={!grade.enabled}
            key={grade.value}
            onClick={() => onSelect(grade.value)}
            type="button"
          >
            <strong className="block text-sm">{grade.label}</strong>
            <span className="mt-1 flex items-center gap-1 text-[10px] font-semibold uppercase tracking-wide">
              {!grade.enabled && <SafeIcon icon={FiLock} />}
              {grade.enabled ? 'Pilot grade' : 'Coming soon'}
            </span>
          </button>
        ))}
      </div>

      {showContinue ? (
        <div className="mt-8 flex justify-end">
          <button
            className="flex items-center gap-2 rounded-xl bg-[#7c3aed] px-5 py-3 text-sm font-semibold text-white transition hover:bg-[#5b21b6] disabled:cursor-not-allowed disabled:opacity-50"
            disabled={selectedGrade !== '7th'}
            onClick={onContinue}
            type="button"
          >
            Continue
            <SafeIcon icon={FiArrowRight} />
          </button>
        </div>
      ) : null}
    </div>
  );
}

export default GradeStep;